import { formatCurrency } from './formatCurrency';

/**
 * Format a Stripe monetary amount for display.
 *
 * Stripe returns money as integer minor units (cents). Divide by 100 before
 * rendering so formatCurrency (which takes whole units) produces the right
 * string. Null/undefined renders as an em dash.
 */
export function formatStripeAmount(
  amountMinor: number | null | undefined,
  currency: string | null | undefined,
): string {
  if (amountMinor === null || amountMinor === undefined) return '—';
  return formatCurrency(amountMinor / 100, currency ?? undefined);
}

/**
 * Format an ISO datetime string as a locale date. Null/undefined/invalid
 * values render as an em dash.
 */
export function formatDate(value: string | null | undefined): string {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString();
}
